import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { DATA_GA_ID_KEY, DATA_GA_NAME_KEY } from './gaConstants';
import styles from './HpRespShopByModuleItem.scss';

function HpRespShopByModuleItem({ item, attrs, className, isTopRow, onClick }) {
    const classNames = classnames(
        styles.wrapper,
        { [styles.topRow]: isTopRow, [styles.bottomRow]: !isTopRow },
        className
    );

    return (
        <div className={classNames} {...attrs} data-tn={item.title.toLowerCase().replace(' ', '-')}>
            <a href={item.link} className={styles.link} onClick={onClick}>
                <span
                    className={styles.background}
                    style={{ backgroundImage: `url(${item.imageUrl})` }}
                />
                <span className={styles.title}>{item.title}</span>
            </a>
        </div>
    );
}

HpRespShopByModuleItem.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string,
        link: PropTypes.string,
        imageUrl: PropTypes.string,
    }).isRequired,
    attrs: PropTypes.shape({
        [DATA_GA_ID_KEY]: PropTypes.string.isRequired,
        [DATA_GA_NAME_KEY]: PropTypes.string.isRequired,
    }).isRequired,
    className: PropTypes.string,
    isTopRow: PropTypes.bool,
    onClick: PropTypes.func,
};

HpRespShopByModuleItem.defaultProps = {
    onClick: () => {},
};

export { HpRespShopByModuleItem };
